import { WorkspaceAutoArchiveRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/auto_archive')({
  component: WorkspaceAutoArchiveRoute,
});
